import object from 'helpers/object'


export const initialState = {
  step: 'schedule',
  schedule: [],
  scheduleTickets: [],
  isFetching: true,
}

export const updateSchedule = (state, payload) => (
  object.setIn(state, [ 'schedule' ], [ ...state.schedule.concat(payload) ])
)

export const setFetching = (state, payload) => (
  object.setIn(state, [ 'isFetching' ], payload)
)

export const setScheduleTickets = (state, payload) => (
  object.setIn(state, [ 'scheduleTickets' ], payload)
)

export const resetSchedule = (state) => (
  object.setIn(state, [ 'schedule' ], [])
)
